export enum AVAILABLE_TIME {
  'ALL' = 'ALL_DAY',
  'TEN_TO_NOON' = '1012',
  'TWO_TO_FOUR' = '1416',
  'FOUR_TO_SIX' = '1618',
}

export const CONST_AVAILABLE_TIME = Object.values(AVAILABLE_TIME);
